import { PlatformAuthorizer, AuthorizationData } from '@quickplay/platform-authorizer';
import { Error, isError } from '@quickplay/foundation';
import { LicenceHandler } from './LicenseHandler';

export async function getLicenseHandler(platformAuthorizer: PlatformAuthorizer): Promise<LicenceHandler> {
  try {
    const authorizationData: AuthorizationData | Error = await platformAuthorizer.ensureAuthorization();
    if (!isError(authorizationData)) {
      return {
        licenseRequestHandler: function (request: any): void {
          // Exception case
          // For legacy players (PS4) which do not support intercepting
          // license requests and appending headers, we should add the token in
          // the request as query param
          if (!request.headers && request.authToken === 'query' && request.uris && request.uris.length > 0) {
            const queryDelimiter = request.uris[0].indexOf('?') >= 0 ? '&' : '?';
            request.uris[0] += `${queryDelimiter}authorization=${authorizationData.accessToken}`;
          } else {
            // Default case
            // Always prefer appending Auth headers via HTTP Headers
            request.headers['Authorization'] = `Bearer ${authorizationData.accessToken}`;
          }
        },
        licenseResponseHandler: function (_response: any): void {
          // no-op
        },
      };
    }
    return Promise.reject(authorizationData);
  } catch (error) {
    return Promise.reject(error);
  }
}
